// extracted by mini-css-extract-plugin
export default {"navButtonsContainer":"styles_navButtonsContainer__p-4X+","navButtonsRowContainer":"styles_navButtonsRowContainer__lMoVi"};